import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AuthShell, inputCls, btnCls } from "@/pages/AuthShell";
import { formatApiError } from "@/lib/api";
import { SocialButtons, Divider } from "@/components/SocialButtons";
import { Loader2 } from "lucide-react";

export default function Signup() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 6) return setError("La password deve avere almeno 6 caratteri");
    setLoading(true);
    try {
      await register(email, password, name);
      const plan = params.get("plan");
      if (plan && plan !== "trial") {
        try {
          const b = params.get("billing");
          localStorage.setItem("sg_intended_plan", plan);
          localStorage.setItem("sg_intended_billing", b === "annual" || b === "yearly" ? "annual" : "monthly");
        } catch (e) { /* noop */ }
      }
      navigate("/onboarding");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Crea la tua guida"
      subtitle="Inizia a ospitare meglio in pochi minuti"
      footer={
        <div className="space-y-3">
          <p>Hai già un account? <Link to="/login" className="font-semibold text-blue-600">Accedi</Link></p>
          <p data-testid="signup-legal-note" className="text-xs text-slate-400 leading-relaxed">
            Registrandoti accetti i{" "}
            <Link to="/termini" className="underline hover:text-slate-600">Termini di Servizio</Link>{" "}
            e la{" "}
            <Link to="/privacy" className="underline hover:text-slate-600">Privacy Policy</Link>.
          </p>
        </div>
      }
    >
      <SocialButtons />
      <Divider />
      <form onSubmit={submit} className="space-y-4" data-testid="signup-form">
        <input data-testid="signup-name" placeholder="Il tuo nome" value={name} onChange={(e) => setName(e.target.value)} className={inputCls} required />
        <input data-testid="signup-email" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} required />
        <input data-testid="signup-password" type="password" placeholder="Password (min 6 caratteri)" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} required />
        {error && <p data-testid="signup-error" className="text-sm text-red-500">{error}</p>}
        <button data-testid="signup-submit" type="submit" disabled={loading} className={btnCls}>
          {loading ? <Loader2 className="w-4 h-4 animate-spin mx-auto" /> : "Crea account"}
        </button>
      </form>
    </AuthShell>
  );
}
